import React, { useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Select,
  styled,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Chip,
  OutlinedInput,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { logoutThunk } from "../../redux/thunks/auth.thunk";
import { getCountriesThunk } from "../../redux/thunks/global.thunk";
import Joi from "joi";
import { createBusinessThunk } from "../../redux/thunks/user.thunk";

const Page = () => {
  const schema = Joi.object({
    name: Joi.string().required().min(3).messages({
      "string.min": "Name should have a minimum length of {#limit}",
      "any.required": "Name is a required field",
    }),
    country: Joi.string().required().messages({
      "any.required": "Name is a required field",
    }),
  });

  const [error, setError] = React.useState<{
    name?: string;
    country?: string;
  }>({});
  const [companyForm, setCompanyForm] = React.useState({
    name: "",
    country: "",
  });

  const dispatch = useAppDispatch();
  const { countries } = useAppSelector((state) => state.global);

  useEffect(() => {
    dispatch(getCountriesThunk());
  }, [dispatch]);

  const onSubmit = () => {
    schema
      .validateAsync(companyForm)
      .then((value) => dispatch(createBusinessThunk(value)))
      .catch((err) => {
        setError((state) => ({
          ...state,
          [err.details[0].path[0]]: err.details[0].message,
        }));
      });
  };

  return (
    <Container>
      <Button variant="contained" onClick={() => dispatch(logoutThunk())}>
        Logout
      </Button>
      <Box>
        Add Company
        <TextField
          error={!!error.name}
          helperText={error.name}
          onChange={({ currentTarget }) =>
            setCompanyForm({
              ...companyForm,
              name: currentTarget.value,
            })
          }
        />
        <FormControl sx={{ m: 1, width: 300 }}>
          <InputLabel id="demo-multiple-chip-label">Countries</InputLabel>
          <Select
            labelId="demo-multiple-chip-label"
            error={!!error.country}
            // helperText={error.country}
            value={companyForm.country}
            onChange={({ target }) =>
              setCompanyForm({
                ...companyForm,
                country: target.value,
              })
            }
            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
            renderValue={(selected: string) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 0.5,
                  }}
                >
                  <Chip
                    label={
                      countries.data?.filter(({ id }) => selected === id)[0]
                        .name
                    }
                  />
                </Box>
              );
            }}
          >
            {countries.data?.map(({ id, name }) => (
              <MenuItem key={id} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
          <Button variant="contained" onClick={onSubmit}>
            Add
          </Button>
        </FormControl>
      </Box>
    </Container>
  );
};

export default styled(Page)(() => ({}));
